export default () => ({
  originalUserScrollPos: 0,

  init: function () {
    this.donateButton = this.$el.querySelector('.button');
    this.closeIcon = this.$el.querySelector('.cw-icon-remove');

    if (this.donateButton) {
      this.donateButton.addEventListener(
        'click',
        this.handleDonateClick.bind(this)
      );
    }

    if (this.closeIcon) {
      this.closeIcon.addEventListener(
        'click',
        this.handleCloseClick.bind(this)
      );
    }
  },

  handleDonateClick: function () {
    this.originalUserScrollPos = window.pageYOffset;
    const { body } = document;

    body.style.top = `-${this.originalUserScrollPos}px`;
    body.classList.add('banner-open');
    body.classList.remove('banner-closing');
  },

  handleCloseClick: function () {
    const { body } = document;

    body.style.top = '0';
    body.classList.remove('banner-open');
    body.classList.add('banner-closing');
    window.scrollTo(0, this.originalUserScrollPos);

    setTimeout(() => {
      body.classList.remove('banner-closing');
    }, 750);
  },
});
